<template>
  <div class="mainChapterContainer" @mouseover="scrollDesactivate=true"
       @mouseout="scrollDesactivate=false;">
    <perfect-scrollbar v-show="chapters.length>0" :options="{suppressScrollX:true}" ref="scrollPanel">
      <div class="blockChapterContainer" :class="'modeSub'">
        <div v-for="chapter in chapters" :key="weet.weetID+'chapter'+chapter.time">
          <div class="chapterContainer" @click="setPlayerTime(chapter.time)" :class="{selected:chapter.time===selectedTime}">
            <div class="video">
              <video class="videoElement" :class="chapter.mainMedia.filter"  muted  :src="getUrlForChapter(chapter.time)"/>
              <div class="mask"></div>
            </div>
            <div>
            <div class="chapterTitle">{{ chapter.value }}</div>
            <div class="timeBox">{{ getHumanTimeFor(chapter.time) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="createChapter" v-if="canEditThisWeet">
        <w-button color="outlined" size="small" @click="openChapterEditor" icon="plus"> {{ $t('chapter.weet.add') }}</w-button>
      </div>
      <div class="footer"></div>
    </perfect-scrollbar>
    <div class="emptyState" v-if="showEmptyState">
      {{ $t('chapter.weet.empty') }}
      <br/>
      <div class="createTrancriptEmpty" v-if="canEditThisWeet">
        <w-button color="outlined" size="small" @click="openChapterEditor" icon="plus"> {{ $t('chapter.weet.add') }}</w-button>
      </div>
    </div>
    <div class="opaqueLayoutTop" v-if="!showEmptyState">

    </div>
    <div class="opaqueLayoutBottom" v-if="!showEmptyState">

    </div>

  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import WIcon from '@/components/wrapper/w-icon.vue';
import {getVideoURLForStatus} from '@/utils/util';
// @ts-ignore
import srtParser from 'subtitles-parser';
import {canEditThisWeet, getHumanTime, getMediasForWeet, launchWeetCreation,} from '@/utils/weetUtil';
import {Weet} from '@/store/weet/weetModel';
import UserAvatar from '@/components/user/UserAvatar.vue';
import store from '@/store';
import {PLAYER_PLAYING, SEEK_PLAYER} from '@/store/timeLine/timeLineAction';
import WButton from '@/components/wrapper/w-button.vue';
import throttle from 'lodash/throttle';
import VueScrollTo from 'vue-scrollto';
import WSelect from "@/components/wrapper/w-select.vue";
import GoToSubtitleWeetButton from "@/components/actionButton/GoToSubtitleWeetButton.vue";
import {TimeEvent} from "@/store/timeLine/timeEvent";
import {SELECT_MODE} from "@/store/advancedEditing/advancedEditingAction";
import {AdvancedEditingMode} from "@/enum/AdvancedEditingMode";
import {getTimeEventbeforeTime} from "@/utils/timeLineUtils";
import {TimeEventType} from "@/enum/TimeEventType";

@Component(
    {
      components: {GoToSubtitleWeetButton, WSelect, WButton, UserAvatar, WIcon, WToolTip},
    })
export default class ChapterPanel extends Vue {
  // this is the result
  @Prop({default: ''})
  private weet!: Weet;
  private scrollDesactivate: boolean = false;

  private showEmptyState: boolean = false;

  private teSelected:TimeEvent|null=null;


  get chapters(): TimeEvent[] {
    if (!this.weet) {
      this.showEmptyState = true;
      return [];
    }
    var listChapter=this.weet.timeLine.filter((te) => {
      return te.type === 'CHAPTER_TITLE';
    });
    this.showEmptyState = listChapter.length==0;
    return listChapter;
  }

  private debouceScroll = throttle((timer: number) => {
    this.scrollToElement(timer);
  }, 1000);

  // subtitle
  public mounted() {
  }

  get selectedTime():number{
    if(this.teSelected){
      return this.teSelected.time;
    }
    return -1;
  }

  get timer(): number {
    return store.getters.getTimerPlayer;
  }


  public openChapterEditor() {
    store.dispatch(SELECT_MODE, AdvancedEditingMode.CHAPTER);
    launchWeetCreation(this.weet.weetID);
  }

  @Watch('timer')
  public changeSubtitleSelected() {
    this.teSelected=null;
    for(const chapter of this.chapters) {
      if (this.timer >= chapter.time) {
        this.teSelected = chapter;
      }
    }
  }

  public getUrlForChapter(time:number){
    for(const chapter of this.chapters) {
      if (time === chapter.time) {

        var timeEventMedia=getTimeEventbeforeTime(this.weet.timeLine,chapter.time,TimeEventType.MEDIA_PLAY)
        if(timeEventMedia) {
          var media = getMediasForWeet(this.weet, timeEventMedia.mainMedia.mediaID);
          if (media) {
            var timeScreen = chapter.time;
            timeScreen = chapter.time - timeEventMedia.time;
            return getVideoURLForStatus(media) + '#t=' + (timeScreen / 1000);
          }
        }
      }
    }
    return "none";
  }

  get canEditThisWeet(): boolean {
    return canEditThisWeet(this.weet);
  }


  public getHumanTimeFor(time: number): string {
    return getHumanTime(time);
  }

  public setPlayerTime(time: number) {
    store.dispatch(SEEK_PLAYER, time).then(() => {
      store.dispatch(PLAYER_PLAYING, true);
    });
  }


  public scrollToElement(timer: number) {
    if (this.scrollDesactivate) {
      return;
    }

    // @ts-ignore
    const panel = this.$refs.scrollPanel.$el as HTMLDivElement;

    let el: any = this.$refs['subtitle_' + timer];
    if (el && el.length > 0) {
      el = el[0];
    }
    const options = {
      container: panel,
      easing: 'ease-in-out',
      lazy: true,
      offset: -100,
      force: false,
      cancelable: true,
      onStart: (element) => {
        // scrolling started
      },
      onDone: (element) => {
        // scrolling is done
      },
      onCancel: () => {
        // scrolling has been interrupted
      },
      x: false,
      y: true
    };
    // we have to wait the panel is open in fullscreenmode
    this.$nextTick(() => {
      VueScrollTo.scrollTo(el, 1000, options);
    });
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/gridBreakPoint.scss";

.mainChapterContainer {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 0px;
  text-align: left;
  height: 100%;
  position: relative;

  .createChapter{
    text-align: center;
    margin-top: 24px;
  }
  .emptyState {
    margin-top: 16px;
    margin-left: 16px;
    min-height: 100px;
    text-align: center;

    .createTrancriptEmpty {
      text-align: center;
      margin-top: 16px;
    }
  }

  .blockChapterContainer {
    margin-left: 4px;
    margin-top: 16px;

    .chapterContainer {
      cursor: pointer;
      padding: 4px;
      padding-top: 8px;
      padding-bottom: 8px;
      border-radius: 8px;
      display: flex;
      .video {
        position: relative;
        max-height: 48px;
        margin-right: 16px;
        .videoElement {
          background: var(--light);
          border: solid 1px var(--light1);
          object-fit: cover;
          border-radius: 8px;
          min-width: 90px;
          max-width: 90px;
          max-height: 48px;
        }
      }
      .timeBox {
        color: var(--dark);
        font-weight: 600;
        font-size: 14px;
        min-width: 42px;
        margin-right: 0px;
      }
      &:hover{
        background: var(--light);
      }

      .chapterTitle {
        font-size: 16px;
        color: var(--black);
        font-weight: 700;
      }


      &.selected {
        background: var(--light);
        .chapterTitle {
          font-weight: 800;
          letter-spacing: 0.0px;
          border-radius: 8px;
        }

      }
    }
  }

  .opaqueLayoutTop {
    width: 100%;
    height: 12px;
    position: absolute;
    top: -4px;
    background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  }

  .opaqueLayoutBottom {
    width: 100%;
    height: 30px;
    position: absolute;
    bottom: 0px;
    background: linear-gradient(rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 1));
    @include GRID1X {
      display: none;
    }
    // background: red;
  }

  .ps {
    max-width: 400px;
    max-height: calc(100vh - 220px);
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 32px;
    min-height: 320px;
    @include GRID1X {
      padding-right: 0px;
    }
  }

  .footer {
    height: 150px;
    background: rgba(0, 0, 0, 0);
  }
}

</style>
